import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Close } from "@mui/icons-material";
import genericStyles from "../Styles/genericStyles.module.css";
import { EWidths } from "../Utils/Enums";
import { GenericModalProps } from "../Utils/Types";
import { isMobile } from "../Utils/Utils";

export default function GenericModal(props: GenericModalProps) {
  const {
    open,
    children,
    className,
    onClose,
    actions,
    title,
    maxWidth,
    otherOptions,
    width,
  } = props;
  return (
    <Dialog
      open={open}
      className={`${className ? className : ""}`}
      style={props.style}
      PaperProps={{
        sx: {
          height: "auto",
          overflowY: "hidden",
          width: isMobile() ? "95vw" : width,
        },
      }}
      maxWidth={maxWidth ? maxWidth : EWidths.SM}
    >
      <DialogTitle
        className={genericStyles.genericModalTitleContainer}
        sx={{
          backgroundColor: "primary.main",
          color: "textColorSecondary.main",
        }}
      >
        <div className={genericStyles.genericModalExtraOption}>
          <p>{title}</p>
          <div>{otherOptions}</div>
        </div>
        <p>
          <Close
            onClick={onClose}
            className={genericStyles.genericModalCloseIcon}
          />
        </p>
      </DialogTitle>
      <DialogContent className={genericStyles.genericModalDialogContent}>
        {children}
      </DialogContent>

      {actions ? (
        <div className={genericStyles.genericModalActionsContainer}>
          {actions}
        </div>
      ) : null}
    </Dialog>
  );
}
